import React from 'react'
import { Box } from '@material-ui/core'

import { ScreenLoading } from 'layouts/Main/components'

import useAuth from 'hooks/useAuth'
import useClientPortalTheme from 'hooks/useClientPortalTheme'

import { ReactComponent as HexagonDetail } from 'images/hexagon-background-auth.svg'
import logoDponetWhite from 'images/logo-dponet-white.svg'
import useStyles from './styles'

const NewAuth = ({ children }) => {
  const { clientPortalTheme, isLoading } = useClientPortalTheme()
  const auth = useAuth()

  const classes = useStyles({ clientPortalTheme })()

  return (
    <ScreenLoading loaded={!isLoading && auth.loaded}>
      <Box component="main" className={classes.root}>
        <HexagonDetail className={classes.detailTopLeft} />
        <HexagonDetail className={classes.detailBottomRight} />
        <Box className={classes.cardColumn}>
          <Box className={classes.wrapper}>
            <Box height="100%">{children}</Box>
          </Box>
        </Box>
        <Box className={classes.rightBanner}>
          <img
            src={clientPortalTheme?.logo || logoDponetWhite}
            alt="Logo"
            className={classes.dponetLogo}
          />
        </Box>
      </Box>
    </ScreenLoading>
  )
}

export default NewAuth
